import { Component } from '@angular/core';

import { PortalModalBaseComponent } from '../portal-modal/portal-modal-base.component';

// The WeProject Privacy Notice, read-only, in the shared portal modal. Held in the template and styled inline, for
// the same reasons as the Terms of Use: it is reissued as a whole, so replacing it is one paste.
@Component({
	selector: 'portal-privacy-modal',
	templateUrl: './privacy-modal.component.html'
})
export class PrivacyModalComponent extends PortalModalBaseComponent {

	open(): void {
		this.modal.open();
	}

}
